import { Button } from '@mui/material';
import { FC } from 'react';
import { CloseIcon } from '../../assets/CloseIcon';
import { Container, Modal, ErrorText, Close } from './ErrorDialog.helper';

interface ErrorDialogProps {
  errorMessage?: string;
  isOpen: boolean;
  onClose: () => void;
}

export const ErrorDialog: FC<ErrorDialogProps> = ({ onClose, isOpen, errorMessage }) => {
  return (
    <Container>
      <Modal $isOpen={isOpen}>
        <Close onClick={onClose}>
          <CloseIcon />
        </Close>
        <ErrorText mb="40px">
          {errorMessage}
        </ErrorText>
        <Button color="primary" fullWidth variant="contained" onClick={onClose}>
          Ok
        </Button>
      </Modal>
    </Container>
  );
};
